<div class="gts" data-testid="github-token-section">
  <div class="gts__card">
    <div class="gts__row" [class.gts__row--missing]="!tokenSet()">
      <div class="gts__row-head">
        <div class="gts__tile" aria-hidden="true">
          <i class="fa-brands fa-github"></i>
        </div>

        <div class="gts__host-col">
          <div class="gts__host-line">
            <span class="gts__badge">{{ 'githubToken.provider' | translate }}</span>
            <code class="gts__host">{{ 'githubToken.host' | translate }}</code>
          </div>
          <div class="gts__usage">{{ 'githubToken.usage' | translate }}</div>
        </div>

        <div class="gts__status" role="status" aria-live="polite" data-testid="github-token-state">
          @if (tokenSet()) {
            <span class="gts__pill gts__pill--set">
              <span class="gts__dot"></span>
              {{ 'githubToken.status.set' | translate }}
            </span>
          } @else {
            <span class="gts__pill gts__pill--missing">
              <span class="gts__dot"></span>
              {{ 'githubToken.status.missing' | translate }}
            </span>
            <small class="gts__meta gts__meta--warning">{{ 'githubToken.status.blocked' | translate }}</small>
          }
        </div>
      </div>

      <div class="gts__expand">
        <div class="gts__expand-head">
          <mat-icon aria-hidden="true">vpn_key</mat-icon>
          {{ 'githubToken.expand.title' | translate }}
        </div>

        <div class="gts__expand-row">
          <label class="sr-only" [for]="inputId">{{ 'githubToken.expand.label' | translate }}</label>
          <input
            [id]="inputId"
            class="gts__input"
            type="password"
            autocomplete="off"
            data-testid="github-token-input"
            [attr.placeholder]="
              (tokenSet() ? 'githubToken.expand.placeholderReplace' : 'githubToken.expand.placeholder') | translate
            "
            [value]="draft()"
            [disabled]="busy()"
            (input)="onDraftInput($event)"
            (keyup.enter)="save()"
          />
          <button
            type="button"
            class="gts__save"
            data-testid="github-token-save"
            [disabled]="!draft().trim() || busy()"
            (click)="save()"
          >
            {{ (tokenSet() ? 'githubToken.action.replace' : 'githubToken.action.save') | translate }}
          </button>
          @if (tokenSet()) {
            <button
              type="button"
              class="gts__delete"
              data-testid="github-token-delete"
              [disabled]="busy()"
              (click)="remove()"
            >
              {{ 'githubToken.action.delete' | translate }}
            </button>
          }
        </div>

        <p class="gts__expand-foot">{{ 'githubToken.help' | translate }}</p>
      </div>
    </div>
  </div>
</div>
